<template>

    <div class="nav-tabs-custom">
        <div class="tab-content">
            <div class="active tab-pane">
                <crm-server-table
                    v-if="loaded"
                    :add-url="route('crm.companies.add', {}, false)"
                    :crm-groups="JSON.stringify(st.crmgroups)"
                    :data-url="st.url"
                    :data-columns="JSON.stringify(st.columns)"
                    :preference-url="st.preferenceUrl"
                ></crm-server-table>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import CrmServerTable from "../../../components/CRM/CrmServerTable";

export default {

    components: {
        CrmServerTable,
    },

    data() {
        return {
            loaded:false,
            st: {
                crmgroups:[],
                columns:[],
                url:'',
                preferenceUrl:'',
            }
        }
    },

    metaInfo: {
        title:'Alle bedrijven',
    },

    methods: {
        getCompaniesData() {
            axios.get(this.route('api.v1.crm.companies.st'))
            .then(resp => {
                this.st = resp.data;
                this.loaded = true;
            })
        }
    },

    mounted() {
        this.getCompaniesData();
    },

    name:'CrmCompaniesIndex',

}

</script>
